import axios from '../utils/axios';

let loaderResponse = {
  uploadResponse: {
    status: 0,
    summary: []
  },
  downloadResponse: {
    filename: '',
    data: null,
    status: false
  },
  listResponse: {
    stores: [],
    status: false
  },
  gsfResponse:{
    status: 0,
    summary: []
  }
};

let fileUploadProgress = 0;


const getFileUploadProgress = () => {
  return fileUploadProgress;
}

const getLatestItems = async(baseurl) => {
  try {
    const url = baseurl+'?limit=6';
    return await axios.get(url);
  } catch(e) {
    console.error("ERROR IN GETTING LATEST ITEM", e);
    throw e;
  }
}

const convertBase64 = async (files) =>
  new Promise((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
      const binaryData = new TextEncoder().encode(fileReader.result);
      const charString = binaryData.reduce((acc, byte) => acc + String.fromCharCode(byte), '');
      resolve(btoa(charString));
    };
    fileReader.readAsText(files, 'UTF-8');
});


const upload = async({files, uploadUrl, data, setContext}) => {
  try {
    const fileName = files[0].name
    const base64Data = await convertBase64(files[0])

    const url = data && data.length ? `${uploadUrl}?fileName=${fileName}&locale=${data}` : `${uploadUrl}?fileName=${fileName}`
    const uploadResponse = await axios.post(url, base64Data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        let percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
        setContext(percentCompleted);
        setTimeout(() => setContext(0), 10000);
      }
    });

    console.log("Upload Response:", uploadResponse.data); // Debugging log

    return handleSuccessfullUpload(uploadResponse);
  } catch(e) {
    return handleFailedUpload();
  }
}

const download = async(downloadUrl) => {
  try {
    const downloadResponse = await axios.get(downloadUrl);
    if([401,403].includes(downloadResponse.status)) {
      // Connection failed
      window.location.href = '/ui/#/403';
    }
    const contentDisposition = downloadResponse?.headers['content-disposition'];
    const fileName = contentDisposition?.match(/filename="([^"]+)"/)?.[1] || "downloaded-file";
    return Object.assign(loaderResponse.downloadResponse, {status: true, data: downloadResponse.data, fileName: fileName });
  } catch(e) {
    return Object.assign(loaderResponse.downloadResponse, {status: false});
  }
}

const handleSuccessfullUpload = (response) => {
  const { summary, errors } = response.data;
  let success = 0;

  if(summary.length > 1) {
    if(!errors || errors?.length === 0) {
      success = 1;
    }
    if(errors && errors.length >= 1) {
      success = 0;
    }
  }
  return Object.assign(loaderResponse.uploadResponse, {status: success, summary});
}

const handleFailedUpload = () => {
  return Object.assign(loaderResponse.uploadResponse, {status:0});
}

const fetchGoogleStores = async(listPath) => {
  try {
    const listResponse = await axios.get(listPath);
    if([401,403].includes(listResponse.status)) {
      // Connection failed
      window.location = '/ui/#/403'
    }
    return handleFetchGoogleStores(listResponse);
  } catch(e) {
    return Object.assign(loaderResponse.listResponse, {status: false, stores: []});
  }
}

const syncGoogleMerchantCenter = async(gsfPath) => {
  try {
    const gsfResponse = await axios.get(gsfPath);
    if([401,403].includes(gsfResponse.status)) {
      // Connection failed
      window.location = '/ui/#/403'
    }
    return Object.assign(loaderResponse.gsfResponse, {status:0});
  } catch(e) {
    return Object.assign(loaderResponse.gsfResponse, {status: false, stores: []});
  }
}

const handleFetchGoogleStores = (response) => {
  const stores = response.data;
  return Object.assign(loaderResponse.listResponse, {status: true, stores});
}

export { upload, download, getFileUploadProgress, getLatestItems, fetchGoogleStores,syncGoogleMerchantCenter };
